
<div class="rate-container">

    @if (rate.rate.bookingCode && !isInAccordion) {
        <div class="room-booking-code-tag">{{'av.roomHasBookingCode'|translate}} <span class="room-booking-code-name">{{rate.rate.bookingCode}}</span></div>
    }
    @if (rate.rate.isNonRef && !isInAccordion) {
        <div class="room-annotation-tag">{{'av.nonRefundableRate'|translate}}</div>
    }
    @else if (rate.rate.isLastMinute && !isInAccordion) {
        <div class="room-annotation-tag">{{'av.lastMinuteRate'|translate}}</div>
    }


    <div class="rate-texts">
        @if (!isInAccordion) {
            <div class="rate-name">{{rate|formatRateName}}</div>
        }
        <app-truncated-text [text]="rate?.rate?.pim?.rateDescription || rate.rate.rateDescription" [truncateHeight]="truncateHeight"></app-truncated-text>

        <div class="rate-cancel-policy" [innerHTML]="rate?.rate?.pim?.cancellationPolicy"></div>
    </div>
    <div class="rate-actions">
        <div class="row">
            <div class="col-7 rate-price-col">
                @if (settings.get("availability.showOriginalPriceIfDiscount") && rate.totalOriginalPrice > rate.totalPriceForStayWithTaxes) {
                    <div class="rate-original-price" [innerHTML]="rate.totalOriginalPrice|displayPrice" [attr.data-testid]="'rate-original-price'"></div>
                }
                <div class="rate-price" [innerHTML]="rate.totalPriceForStayWithTaxes|displayPrice" [attr.data-testid]="'rate-price'"></div>
            </div>
            <div class="col-5 ">
                <p-button class="w-100" (click)="selectRate($event)" [attr.data-testid]="'select-rate'">
                    {{"av.Select"|translate}}
                    @if (rate.rate.membershipTier) {
                        <span class="material-symbols-outlined" [pTooltip]="'av.memberRate'|translate">
                            vpn_key
                        </span>
                    }
                </p-button>
            </div>
        </div>
    </div>
    <app-availability-debugview [rate]="rate"></app-availability-debugview>

</div>
